import { FuseUtils } from '@fuse/utils';

export class Contact {
  id: string;
  alias: string;
  login: string;
  name: string;
  firstName: string;
  lastName: string;
  profilePhotoUrl?: string;
  avatar: string;
  nickname: string;
  company: string;
  jobTitle: string;
  email: string;
  phone: string;
  address: string;
  birthday: string;
  notes: string;
  creationDate: Date;
  channelId: number;
  userfId: string;
  wsBsuid: string;
  enterpriseName: string;
  /**
   * Constructor
   *
   * @param contact
   */
  constructor(contact) {
    {
      this.id = contact.id || FuseUtils.generateGUID();
      this.alias = contact.alias || null;
      this.login = contact.login || '';
      this.name = contact.name || '';
      this.lastName = contact.lastName || '';
      this.profilePhotoUrl =
        contact && contact.profilePhotoUrl ? contact.profilePhotoUrl : undefined;
      this.avatar = contact.avatar || 'assets/images/avatars/profile.jpg';
      this.nickname = contact.nickname || '';
      this.company = contact.company || '';
      this.jobTitle = contact.jobTitle || '';
      this.email = contact.email || '';
      this.phone = contact.phone || '';
      this.address = contact.address || '';
      this.birthday = contact.birthday || '';
      this.notes = contact.notes || '';
      this.userfId = contact.userfId || '';
      this.wsBsuid = contact.wsBsuid || '';
      this.enterpriseName = contact.enterpriseName || '';
    }
  }
}
